import { Box } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CURRENCY } from "../../../../../config/appConfig";
import { currencyFormatterHelper } from "../../../../../helpers/currencyFormatterHelper";
import { DialogWrapper } from "../../../../../shared/components/common/dialogWrapper";
import { ButtonWrapper } from "../../../../../shared/components/formUtilities/useButton";

export const CancelOrderDialog = ({ state = false, onClose, row }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  return (
    <DialogWrapper
      title={t('cancelOrder')}
      maxWidth="xs"
      width={'440px'}
      state={state}
      onClose={() => {
        onClose(false);
      }}
      content={
        <>
          <Box className="grid grid-flow-row justify-center">
            <Box className='!text-[15px] !text-center mb-3'>
              {t('areYousureCancelOrder')}
            </Box>
            <Box className='flex items-center !text-[13px]'>
              <Box className='md:!w-[120px]'>{t('businessName')}</Box>
              <Box className='w-2'>:</Box>
              <Box className='!font-[500]'>{row?.businessName}</Box>
            </Box>
            <Box className='flex items-center !text-[13px]'>
              <Box className='md:!w-[120px]'>{t('amount')}</Box>
              <Box className='w-2'>:</Box>
              <Box className='!font-[500]'>
                <span className='currency-symbol'>{CURRENCY}</span>
                {` ${currencyFormatterHelper(row?.amount)}`}</Box>
            </Box>
          </Box>
        </>
      }
      actions={
        <Box>
          <ButtonWrapper
            loading={loading}
            classList="!border-[#ccc] !text-black"
            variant={'outlined'}
            label={t('cancelOrderBtn')}
            onClick={() => {
              setLoading(true);
              onClose(true);
            }}></ButtonWrapper>
        </Box>
      }></DialogWrapper>
  );
};